<template>
  <div class="form-col">
    <div class="form-item">
      <label class="form-label">
        <span class="label-text">{{ mode === 'discount' ? '参与人及商品列表：' : '参与人列表：' }}</span>
        <span class="label-tip">👥</span>
      </label>
      <button @click="addPerson" class="btn btn-add">+ 添加参与人</button>
      <small class="field-hint">{{ mode === 'discount' ? '示例：每人添加要购买的商品及价格' : '示例：聚餐时的所有参与者' }}</small>

      <div class="person-list">
        <div v-for="(item, index) in localPersonList" :key="index" class="person-item">
          <!-- 姓名输入（两种模式共有） -->
          <div class="input-group">
            <input
              type="text"
              v-model="item.name"
              placeholder="姓名"
              class="form-input person-name"
              @input="handlePersonChange"
            >
            <small class="input-hint-small">参与者姓名</small>
          </div>

          <!-- Simple 模式：实付金额 -->
          <template v-if="mode !== 'discount'">
            <div class="input-group">
              <input
                type="number"
                v-model.number="item.payAmount"
                min="0"
                placeholder="实付金额"
                class="form-input person-amount"
                @input="handlePersonChange"
              >
              <small class="input-hint-small">实际支付的金额</small>
            </div>
            <button @click="deletePerson(index)" class="btn btn-delete">删除</button>
          </template>

          <!-- Discount 模式：商品列表 -->
          <template v-else>
            <div class="items-section">
              <div v-for="(it, iIdx) in item.items" :key="iIdx" class="item-row">
                <input
                  type="text"
                  v-model="it.itemName"
                  placeholder="商品名"
                  class="form-input item-name"
                  @input="handlePersonChange"
                >
                <input
                  type="number"
                  v-model.number="it.price"
                  min="0"
                  placeholder="价格"
                  class="form-input item-price"
                  @input="handlePersonChange"
                >
                <button @click="deleteItem(index, iIdx)" class="btn btn-delete-item">×</button>
              </div>
              <button @click="addItem(index)" class="btn btn-add-item">+ 添加商品</button>
            </div>
            <div class="person-summary">
              <span class="person-total">小计：{{ personItemTotal(item) }} 元</span>
              <button @click="deletePerson(index)" class="btn btn-delete">删除</button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonManager',
  props: {
    modelValue: {
      type: Array,
      default: () => [{ name: '', payAmount: 0 }]
    },
    mode: {
      type: String,
      default: 'simple'
    }
  },
  data() {
    return {
      localPersonList: JSON.parse(JSON.stringify(this.modelValue))
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        const newValStr = JSON.stringify(newVal)
        const localStr = JSON.stringify(this.localPersonList)
        if (newValStr !== localStr) {
          this.localPersonList = JSON.parse(newValStr)
        }
      },
      deep: true,
      immediate: true
    },
    localPersonList: {
      handler(newVal) {
        this.$emit('update:modelValue', JSON.parse(JSON.stringify(newVal)))
        this.$emit('change', JSON.parse(JSON.stringify(newVal)))
      },
      deep: true
    }
  },
  methods: {
    addPerson() {
      if (this.mode === 'discount') {
        this.localPersonList.push({ name: '', payAmount: 0, items: [{ itemName: '', price: 0 }] })
      } else {
        this.localPersonList.push({ name: '', payAmount: 0 })
      }
    },

    deletePerson(index) {
      if (this.localPersonList.length > 1) {
        this.localPersonList.splice(index, 1)
      } else {
        alert('至少保留1位参与人！')
      }
    },

    addItem(personIndex) {
      if (!this.localPersonList[personIndex].items) {
        this.localPersonList[personIndex].items = []
      }
      this.localPersonList[personIndex].items.push({ itemName: '', price: 0 })
      this.handlePersonChange()
    },

    deleteItem(personIndex, itemIndex) {
      const items = this.localPersonList[personIndex].items
      if (items && items.length > 1) {
        items.splice(itemIndex, 1)
      }
      this.handlePersonChange()
    },

    personItemTotal(person) {
      if (!person.items) return '0.00'
      return (person.items.reduce((s, it) => s + (it.price || 0), 0)).toFixed(2)
    },

    handlePersonChange() {
      this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.localPersonList)))
      this.$emit('change', JSON.parse(JSON.stringify(this.localPersonList)))
    }
  }
}
</script>

<style scoped>
.form-item {
  margin-bottom: 0;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: none;
}

.form-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 12px;
  font-size: 14px;
}

.label-text {
  font-weight: 600;
  color: #4a5568;
}

.label-tip {
  font-size: 18px;
}

.field-hint {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #718096;
  font-style: italic;
}

.person-list {
  margin-top: 16px;
  margin-bottom: 0;
}

.person-item {
  display: flex;
  align-items: stretch;
  margin-bottom: 15px;
  gap: 15px;
  padding: 15px;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 3px solid #667eea;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 120px;
}

.form-input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
  background: #fafafa;
  color: #2d3748;
}

.form-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background: #ffffff;
}

.form-input::placeholder {
  color: #a0aec0;
}

.input-hint-small {
  font-size: 11px;
  color: #a0aec0;
  font-style: italic;
  margin-top: 4px;
  margin-bottom: 0;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-add {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: #fff;
  font-size: 14px;
  padding: 10px 20px;
  margin-bottom: 16px;
}

.btn-add:hover {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
}

.btn-delete {
  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);
  color: #fff;
  font-size: 13px;
  padding: 12px 16px;
  align-self: center;
  white-space: nowrap;
  min-width: 80px;
}

.btn-delete:hover {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
  box-shadow: 0 4px 12px rgba(245, 101, 101, 0.3);
}

/* Discount 模式样式 */
.items-section {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.item-row {
  display: flex;
  gap: 6px;
  align-items: center;
}

.item-row .form-input {
  flex: 1;
  min-width: 60px;
  padding: 8px 10px;
  font-size: 13px;
}

.btn-delete-item {
  background: #e53e3e;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.2;
  flex-shrink: 0;
}

.btn-add-item {
  background: #e2e8f0;
  color: #4a5568;
  border: none;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  align-self: flex-start;
}

.person-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 100px;
}

.person-total {
  font-weight: 700;
  color: #667eea;
  font-size: 14px;
  white-space: nowrap;
}

/* 响应式 */
@media (max-width: 750px) {
  .form-item {
    padding: 12px;
    border-radius: 8px;
  }

  .form-label {
    font-size: 13px;
    margin-bottom: 8px;
  }

  .form-input {
    padding: 8px 12px;
    font-size: 13px;
    border-radius: 4px;
  }

  .person-item {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 10px;
  }

  .input-group {
    width: 100%;
    min-width: auto;
  }

  .btn-delete {
    grid-column: span 2;
    width: 100%;
    padding: 8px 12px;
    font-size: 12px;
  }

  .btn-add {
    margin-bottom: 10px;
    width: auto;
    padding: 8px 16px;
    font-size: 13px;
  }

  .person-list {
    margin-top: 12px;
  }

  .items-section {
    grid-column: span 2;
  }

  .person-summary {
    grid-column: span 2;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .person-summary .btn-delete {
    grid-column: auto;
    width: auto;
  }
}

@media (max-width: 320px) {
  .form-item {
    padding: 14px;
  }

  .form-label {
    font-size: 12px;
  }

  .form-input {
    padding: 9px 12px;
    font-size: 13px;
  }

  .person-item {
    gap: 10px;
    padding: 10px;
  }

  .btn {
    font-size: 13px;
    padding: 10px 16px;
  }

  .label-tip {
    font-size: 16px;
  }
}
</style>
